'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import { safeCall } from '@/app/utils/safeCall';

interface PathWatcherProps {
  isOpen: boolean;
  isDesktop?: boolean;
  closeMenu: () => void;
  setShouldRenderMenu: (status: boolean) => void;
  setActiveItem: (status: undefined) => void;
}

/**
 * This component is created to avoid the first load layout flick
 * because of Suspense and useSearchParams
 **/
export const PathWatcher = ({
  isOpen = false,
  isDesktop = false,
  closeMenu,
  setActiveItem,
  setShouldRenderMenu,
}: PathWatcherProps) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  // Note: Always reset to close state when changing from desktop <-> mobile and page changed
  useEffect(() => {
    safeCall(setShouldRenderMenu, false);
    safeCall(closeMenu);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, isDesktop]);

  useEffect(() => {
    if (!isOpen) return;

    safeCall(closeMenu);
    if (!isDesktop) {
      safeCall(setActiveItem, undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  return null;
};
